import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@mindstonehq/ui";
import { QuestionMarkCircleIcon } from "@heroicons/react/24/outline";
import { Trans, useLingui } from "@lingui/react/macro";
import { msg } from "@lingui/core/macro";

export function DialogConfirm(
  props: React.PropsWithChildren<{
    title: string;
    description: string;
    confirmButtonText?: string;
    confirmButtonProps?: React.ComponentProps<typeof Button>;
    onConfirm: () => any;
    onOpenChange?: (open: boolean) => any;
    initialState?: boolean;
  }>,
) {
  const { t } = useLingui();
  const [open, setOpen] = useState(!!props.initialState);

  return (
    <Dialog
      open={open}
      onOpenChange={(o) => {
        setOpen(o);
        if (props.onOpenChange) {
          props.onOpenChange(o);
        }
      }}
    >
      <DialogTrigger asChild>{props.children}</DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center flex-row space-x-2">
            <QuestionMarkCircleIcon className="h-6 w-6" aria-hidden="true" />
            <span>{props.title}</span>
          </DialogTitle>
        </DialogHeader>
        {props.description}
        <DialogFooter className="gap-2">
          <DialogClose asChild>
            <Button variant="outline"><Trans>Cancel</Trans></Button>
          </DialogClose>
          <DialogClose asChild>
            <Button
              variant="default"
              {...props.confirmButtonProps}
              onClick={props.onConfirm}
            >
              {props.confirmButtonText || t(msg`Confirm`)}
            </Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
